import React, { useState } from "react";
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import { Question } from "../types";
import MultipleChoiceForm from "./MultipleChoiceForm";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import QuestionPreviewContainer from "./QuestionPreviewContainer";
import { useMutation } from "@tanstack/react-query";
import useDeleteSurveyQuestion from "../CustomHooks/useDeleteSureveyQuestion";

interface MultipleChoiceOptionsPreviewDisplayProps {
    question: Question,
    questionText: string;
    options: string[];
}

export default (props: MultipleChoiceOptionsPreviewDisplayProps) => {



    const { question, questionText, options } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);

    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);
    
    const handleEditQuestion = () => {
        setModalOpen(true);       
    }

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
            <div className="flex flex-col gap-4">
                <ul className="flex flex-col gap-5">
                    {options.map((option: string) => {
                        return (
                                <li key={option} className="flex items-center gap-2 text-xl"><TbArrowBadgeRightFilled className="text-[#3da8e2] text-3xl"/>{option}</li>
                        );
                    })}
                </ul>
            </div>
            <MultipleChoiceForm openState={modalOpen} onClose={setModalOpen} question={question}/>
        </QuestionPreviewContainer>
    )
}